const angular = require('angular');
const ngAnimate = require('angular-animate');
const ngMessages = require('angular-messages');
const ngSanitize = require('angular-sanitize');
const uiRouter = require('angular-ui-router');
const restangular = require('restangular'); // eslint-disable-line no-unused-vars
require('dialog-polyfill');
const olyDialog = require('oly-dialog');

const wowCommonModule = require('../common/common.module');
const olyCommonModule = require('../olycommon/olycommon.module');
const recipeModule = require('../recipe/recipe.module');
const analyticsModule = require('../analytics/analytics.module');

const shopModuleName = 'wowApp.shop';

angular.module(shopModuleName, [
    olyCommonModule,
    wowCommonModule,
    analyticsModule,
    recipeModule,
    ngAnimate,
    ngMessages,
    ngSanitize,
    uiRouter,
    'restangular',
    olyDialog,
]);

// ------------------------------------------
// Components
// ------------------------------------------
require('./accessibility');
require('./banners');
require('./browse');
require('./cart');
require('./categories');
require('./dynamicsuburb');
require('./header');
require('./newproducts');
require('./orderinformation');
require('./partner');
require('./price');
require('./productgroups');
require('./shelfproduct');
require('./stores');
require('./productsavetolist');
require('./tiles');
require('./trolley');
require('./trackmyorder');
require('./offergroup');
require('./richrelevance');
require('./notificationpanel');
require('./express');
require('./recommendation');
require('./rating');
require('./review');
require('./onboarding');

module.exports = shopModuleName;



// WEBPACK FOOTER //
// ./src/shop/shop.module.js